import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface LogoProps {
  fontSize?: string;      // default: "1.1rem"
  showAlpha?: boolean;    // default: true
  letterSpacing?: string; // default: "5px"
  style?: React.CSSProperties;
}

export const Logo: FC<LogoProps> = ({ 
  fontSize = '1.1rem', 
  showAlpha = true,
  letterSpacing = '5px',
  style
}) => {
  const { t } = useTranslation();

  return (
    <div 
      className="app-logo-container" 
      style={style}
    >
      <h1 
        className="app-logo-title" 
        style={{ 
          fontSize,
          letterSpacing
        }}
      >
        choreogr
        <span className="app-logo-ai">AI</span>
        phy
      </h1>
      {showAlpha && (
        <span className="app-logo-badge">
          {t('common.preview', 'Preview')}
        </span>
      )}
    </div>
  );
};
